import {FC} from 'react';
import UINoImage from './UINoImage';

import addDefaultSrc from '../../assets/images/placeholder.png';

type UIImageProps = {
  url: string;
  style?: string;
  rollBackImage?: string;
}

const UIImage: FC<UIImageProps> = ({url, style, rollBackImage}) => {
  if (url == null) {
    return (
      <UINoImage style={style}/>
    );
  }
  return (
    <img
      src={url}
      className={`w-full h-full object-cover ${style}`}
      onError={(e) => {
        (e.target as HTMLImageElement).onerror = null;
        (e.target as HTMLImageElement).src = rollBackImage || addDefaultSrc;
      }}/>
  );
};

export default UIImage;
